// Dataset Pages Common JavaScript - Shared across all dataset pages

document.addEventListener('DOMContentLoaded', function() {
    console.log('Dataset page loaded');
    
    // Initialize all components
    initializeAnimations();
    initializeModal();
    initializeSampleTabs();
    initializeFormHandling();
    // Scroll animations removed for better performance
});

// Enhanced scroll animations for institutional feel
function initializeScrollAnimations() {
    const observerOptions = {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('animate-in');
                
                // Stagger animations for grids
                if (entry.target.classList.contains('fiscal-features-grid') || 
                    entry.target.classList.contains('fiscal-use-cases-grid')) {
                    const items = entry.target.children;
                    Array.from(items).forEach((item, index) => {
                        setTimeout(() => {
                            item.classList.add('animate-in');
                        }, index * 150);
                    });
                }
            }
        });
    }, observerOptions);

    // Observe all animatable elements
    const animatableElements = document.querySelectorAll(`
        .fiscal-hero-content,
        .fiscal-features-grid,
        .fiscal-use-cases-grid,
        .fiscal-sample-content,
        .fiscal-cta-content
    `);
    
    animatableElements.forEach(el => observer.observe(el));
}

// Add animation CSS
const animationStyle = document.createElement('style');
animationStyle.textContent = `
    .animate-in {
        animation: slideInUp 0.8s cubic-bezier(0.4, 0, 0.2, 1) forwards;
    }
    
    @keyframes slideInUp {
        from {
            opacity: 0;
            transform: translateY(30px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }
`;
document.head.appendChild(animationStyle);

// Enhanced animations
function initializeAnimations() {
    // Smooth scroll for anchor links
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
            e.preventDefault();
            const target = document.querySelector(this.getAttribute('href'));
            if (target) {
                target.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            }
        });
    });

    // Enhanced hover effects for feature cards
    const featureCards = document.querySelectorAll('.fiscal-feature-card, .fiscal-use-case-card');
    featureCards.forEach(card => {
        card.addEventListener('mouseenter', function() {
            this.style.transform = 'translateY(-12px) scale(1.02)';
            this.style.boxShadow = '0 25px 70px rgba(0, 0, 0, 0.7)';
        });
        
        card.addEventListener('mouseleave', function() {
            this.style.transform = '';
            this.style.boxShadow = '';
        });
    });

    // Parallax scroll effect removed
}

// Sample tabs functionality
function initializeSampleTabs() {
    const tabs = document.querySelectorAll('.sample-tab');
    const contents = document.querySelectorAll('.sample-content');
    
    tabs.forEach(tab => {
        tab.addEventListener('click', function() {
            const targetTab = this.getAttribute('data-tab');
            
            // Remove active class from all tabs and contents
            tabs.forEach(t => t.classList.remove('active'));
            contents.forEach(c => c.classList.remove('active'));
            
            // Add active class to clicked tab and corresponding content
            this.classList.add('active');
            const targetContent = document.querySelector(`.sample-content[data-tab="${targetTab}"]`);
            if (targetContent) {
                targetContent.classList.add('active');
            }
        });
    });
}

// Enhanced modal functionality
function initializeModal() {
    const modal = document.getElementById('demoModal');
    const modalContent = modal?.querySelector('.modal-content');
    
    if (!modal) return;

    // Close modal function
    window.closeDemoModal = function() {
        modal.classList.remove('show');
        document.body.style.overflow = '';
        
        // Reset form
        const form = modal.querySelector('#demoForm');
        if (form) {
            form.reset();
            hideMessages();
        }
    };

    // Open modal function
    window.openDemoModal = function() {
        modal.classList.add('show');
        document.body.style.overflow = 'hidden';
        
        // Focus first input
        setTimeout(() => {
            const firstInput = modal.querySelector('input[type="text"]');
            if (firstInput) firstInput.focus();
        }, 300);
    };

    // Close on background click
    modal.addEventListener('click', function(e) {
        if (e.target === modal) {
            closeDemoModal();
        }
    });

    // Close on escape key
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && modal.classList.contains('show')) {
            closeDemoModal();
        }
    });

    // Prevent modal content click from closing modal
    if (modalContent) {
        modalContent.addEventListener('click', function(e) {
            e.stopPropagation();
        });
    }
}

// Enhanced form handling
function initializeFormHandling() {
    const form = document.getElementById('demoForm');
    if (!form) return;

    // Form validation
    const validateForm = (formData) => {
        const required = ['first_name', 'last_name', 'email', 'phone', 'job_title', 'company', 'institution_type'];
        const missing = required.filter(field => !formData.get(field)?.trim());
        
        if (missing.length > 0) {
            throw new Error(`Please fill in all required fields: ${missing.join(', ')}`);
        }
        
        // Email validation
        const email = formData.get('email');
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
            throw new Error('Please enter a valid email address');
        }
        
        return true;
    };

    // Enhanced form submission
    form.addEventListener('submit', async function(e) {
        e.preventDefault();
        
        const submitButton = form.querySelector('.submit-button');
        const originalText = submitButton.textContent;
        
        try {
            // Show loading state
            submitButton.textContent = 'Submitting...';
            submitButton.disabled = true;
            hideMessages();
            
            const formData = new FormData(form);
            
            // Validate form
            validateForm(formData);
            
            // Convert to JSON
            const data = Object.fromEntries(formData.entries());
            data.source = getDatasetSource();
            data.dataset_interest = getDatasetName();
            data.timestamp = new Date().toISOString();
            
            // Submit form
            const response = await fetch('/api/contact', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRFToken': window.csrfToken || '',
                },
                body: JSON.stringify(data)
            });
            
            if (!response.ok) {
                throw new Error(`Server error: ${response.status}`);
            }
            
            const result = await response.json();
            
            if (result.success) {
                showSuccessMessage();
                form.reset();
                
                // Auto-close modal after success
                setTimeout(() => {
                    closeDemoModal();
                }, 3000);
            } else {
                throw new Error(result.message || 'Submission failed');
            }
            
        } catch (error) {
            console.error('Form submission error:', error);
            showErrorMessage(error.message);
        } finally {
            // Restore button state
            submitButton.textContent = originalText;
            submitButton.disabled = false;
        }
    });

    // Real-time validation feedback
    const inputs = form.querySelectorAll('input[required], select[required]');
    inputs.forEach(input => {
        input.addEventListener('blur', function() {
            if (this.value.trim()) {
                this.style.borderColor = 'rgba(74, 222, 128, 0.5)';
            } else {
                this.style.borderColor = 'rgba(248, 113, 113, 0.5)';
            }
        });
        
        input.addEventListener('input', function() {
            if (this.style.borderColor === 'rgba(248, 113, 113, 0.5)' && this.value.trim()) {
                this.style.borderColor = '';
            }
        });
    });
}

// Helper functions to get dataset-specific information
function getDatasetSource() {
    // Extract dataset source from body class or page title
    const bodyClass = document.body.className;
    if (bodyClass.includes('amazon-search')) return 'amazon_search_page';
    if (bodyClass.includes('google-search-trends')) return 'google_search_trends_page';
    if (bodyClass.includes('mobile-app')) return 'mobile_app_page';
    if (bodyClass.includes('reddit-analytics')) return 'reddit_analytics_page';
    if (bodyClass.includes('tiktok-trends')) return 'tiktok_trends_page';
    if (bodyClass.includes('web-traffic')) return 'web_traffic_page';
    if (bodyClass.includes('youtube-search-data')) return 'youtube_search_data_page';
    return 'dataset_page';
}

function getDatasetName() {
    // Extract dataset name from page title
    const title = document.querySelector('h1 .hero-title-main');
    return title ? title.textContent.trim() : 'Dataset';
}

// Message display functions
function showSuccessMessage() {
    const successMsg = document.getElementById('successMessage');
    const errorMsg = document.getElementById('errorMessage');
    
    if (errorMsg) errorMsg.style.display = 'none';
    if (successMsg) {
        successMsg.style.display = 'block';
        successMsg.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
}

function showErrorMessage(message) {
    const successMsg = document.getElementById('successMessage');
    const errorMsg = document.getElementById('errorMessage');
    
    if (successMsg) successMsg.style.display = 'none';
    if (errorMsg) {
        errorMsg.style.display = 'block';
        const messageElement = errorMsg.querySelector('br').nextSibling;
        if (messageElement) {
            messageElement.textContent = message || 'Please try again later.';
        }
        errorMsg.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
}

function hideMessages() {
    const successMsg = document.getElementById('successMessage');
    const errorMsg = document.getElementById('errorMessage');
    
    if (successMsg) successMsg.style.display = 'none';
    if (errorMsg) errorMsg.style.display = 'none';
}

// Performance optimizations
function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
        const later = () => {
            clearTimeout(timeout);
            func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}

// Throttled scroll handler for better performance
const throttledScrollHandler = debounce(() => {
    const scrolled = window.pageYOffset;
    const parallaxElements = document.querySelectorAll('.fiscal-hero-section, .fiscal-use-cases-section');
    
    parallaxElements.forEach(element => {
        const speed = 0.3;
        element.style.transform = `translateY(${scrolled * speed}px)`;
    });
}, 16); // ~60fps
